import { Component } from '@angular/core';

@Component({
  selector: 'app-template-view',
  standalone: true,
  imports: [],
  templateUrl: './template-view.component.html',
  styleUrl: './template-view.component.scss'
})
export class TemplateViewComponent {

}
